module.exports = __webpack_public_path__ + "static/media/12.f236a816.jpg";